import BaseObject from "./BaseObject.js";
import appConfig from "../../config/app_config";
// import { Object } from "ol";
export default class ProductObject {
  static _objectDefinition(object = null) {
    if (object != null && object.hasOwnProperty("Id")) {
      let categoryObj = {};
      if(Object.keys(object.Categories).length > 0)
      {
        categoryObj = {
          id: Number(Object.keys(object.Categories)[0]),
          description: Object.values(object.Categories)[0]
        }
      }

      return {
        ForAge: object.ForAge,
        Id: object.Id,
        Name: object.Name,
        Description: object.Description,
        Brand: object.Brand,
        Picture: object.Picture,
        VatPercentage: object.VatPercentage,
        ItemDef: object.ItemDef,
        Price: object.Price,
        Capacity: object.Capacity,
        Items: object.Items,
        Categories: object.Categories,
        PriceCategories: object.priceCategories,
        ProductCategory: categoryObj,
        Type: object.Type,
        WeightedInfo: object.WeightedInfo
      }
    }
    return {
      EventId: null,
      Name: "",
      Description: "",
      Picture: "",
      Brand: "",
      Capacity: 0,
      Price: 0,
      VatPercentage: 0,
      ForAge: 0,
      Tags: {},
      PriceCategories: {},
      ProductCategory: {},
      Type: "Standard",
      WeightedInfo: {
        Unit: '',
        StepSize: null,
        PricePerStep: null,
        Minimum: null,
        OverviewSize: null,
        FixedPrice: false
      }
    };
  }

  static _createProductObject(object, event) {
    if (object.ForAge == null) {
      object.ForAge = 0;
    };

    // Evaluate WeightedInfo
    let weightedInfo = {
      Unit: '',
      StepSize: null,
      PricePerStep: null,
      Minimum: null,
      OverviewSize: null,
      FixedPrice: false
    };

    if(object.hasOwnProperty("WeightedInfo")) {
      if(object.WeightedInfo.hasOwnProperty("Unit")) {
        weightedInfo.Unit = object.WeightedInfo.Unit;
      }
      if(object.WeightedInfo.hasOwnProperty("StepSize")) {
        weightedInfo.StepSize = object.WeightedInfo.StepSize;
      }
      if(object.WeightedInfo.hasOwnProperty("PricePerStep")) {
        weightedInfo.PricePerStep = object.WeightedInfo.PricePerStep;
      }
      if(object.WeightedInfo.hasOwnProperty("Minimum")) {
        weightedInfo.Minimum = object.WeightedInfo.Minimum;
      }
      if(object.WeightedInfo.hasOwnProperty("OverviewSize")) {
        weightedInfo.OverviewSize = object.WeightedInfo.OverviewSize;
      }
      if(object.WeightedInfo.hasOwnProperty("FixedPrice")) {
        weightedInfo.FixedPrice = object.WeightedInfo.FixedPrice;
      }
    }

    let requestObject = {};
    if (object.hasOwnProperty("Id")) {
      let categoryObj = {};
      // if(Object.keys(object.Categories).length > 0)
      // {
      //   categoryObj = {
      //     [Object.keys(object.Categories)[0]]: Object.keys(object.Categories)[0]
      //   }
      // }
      // else
      // {
        if (object.hasOwnProperty("ProductCategory") && Object.keys(object.ProductCategory).length > 0)
        {
          categoryObj = {
            [object.ProductCategory.id]: object.ProductCategory.id
          }
        }
      // }

      requestObject = {
        ProductId: object.Id,
        EventId: event.eventId,
        Name: object.Name,
        Description: object.Description,
        Brand: object.Brand,
        Picture: object.Picture,
        Capacity: Number(object.Capacity),
        Price: Number(object.Price),
        VatPercentage: Number(object.VatPercentage),
        ForAge: Number(object.ForAge),
        Tags: {
          ProductCategory: categoryObj
        },
        PriceCategories: object.PriceCategories,
        Type: object.Type,
        WeightedInfo: weightedInfo
      };
    } else {
      requestObject = {
        EventId: event.eventId,
        Name: object.Name,
        Description: object.Description,
        Brand: object.Brand,
        Picture: object.Picture,
        Capacity: Number(object.Capacity),
        Price: Number(object.Price),
        VatPercentage: Number(object.VatPercentage),
        ForAge: Number(object.ForAge),
        Tags: {
          ProductCategory: {
            [object.ProductCategory.id]: object.ProductCategory.id
          }
        },
        PriceCategories: object.PriceCategories,
        Type: object.Type,
        WeightedInfo: weightedInfo
      };
    }
    return requestObject;
  }

  // static deleteRequestProduct(object) {
  //   let reqObj = {
  //     Id: Number(object.Id)
  //   };
  //   return reqObj;
  // }

  // static _createArrayWithObjects(batchGroup) {
  //   let result = BaseObject._createArrayWithObjects(batchGroup);
  //
  //   return result;
  // }
}
